module.exports = __webpack_public_path__ + "img/3213r.34417c86.jpg";